import { render } from "./HeaderHjpTable.vue?vue&type=template&id=78e21752&ts=true"
import script from "./HeaderHjpTable.vue?vue&type=script&lang=ts"
export * from "./HeaderHjpTable.vue?vue&type=script&lang=ts"

import "./HeaderHjpTable.vue?vue&type=style&index=0&id=78e21752&lang=scss"

import exportComponent from "/builds/harapan-jaya/ecosystem/web-hrd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__